class defaultPage {
  init() {
    // h1 hacks
    if($('.default-page--content h2').length>0){
      $('.default-page--content--wrap').addClass('h2d');
    }
    $('.default-page--content h2').each(function(){
      var t = $(this).text();
      var id = t.toLowerCase().replaceAll(' ','').trim();
      $(this).attr('id', id);
    });

    // h5 hacks
    if($('.default-page--content h5').length>0){
      if($('.default-page--content--wrap').hasClass('h2d')) {
        $('.default-page--content--wrap h2').each(function(){
          var h5wrap = $('<div class="default-page--content--wrap h5d"></div>');
          $(h5wrap).insertAfter($(this));
          $(this).nextUntil('h2, h5').appendTo(h5wrap);
        });
      } else {
        $('.default-page--content--wrap').addClass('h5d');
      }
    }
    $('.default-page--content h5, .default-page--content h6').each(function(){
      var t = $(this).text();
      var id = t.toLowerCase().replaceAll(' ','').trim();
      id = id.replace(/[^a-zA-Z ]/g, "");
      $(this).attr('id', id);
      var el = $('<a href="#'+id+'">'+t+'</a>');
      $('.h5-links').append(el)
    });

    $('.h5-links a').unbind('click').click(function(e){
      e.preventDefault();
      var target = $(this).attr('href');
      var pos = $(target).offset().top;
      if(window.innerWidth > 767) {
        $('html, body').animate({'scrollTop' : pos - parseInt($('html').css('font-size')) * 3}, 400);
      } else {
        $('html, body').animate({'scrollTop' : pos - 50}, 400);
      }
    });

    if(window.innerWidth <= 767) {
      if($('.h5-links a').length>3) {
        var el = $('<a href="#contents" class="tog-contents mobonly"></a>');

        // initial label uses theme string if available
        el.text(window.themeStrings && window.themeStrings.contents ? window.themeStrings.contents : 'Contents');

        $(el).insertBefore('.h5-links');
        $(el).on('click', function(e){
          e.preventDefault();
          $('.h5-links').slideToggle(300);

          $(this).toggleClass('on');

          var tx = $(this).hasClass('on') ? (window.themeStrings && window.themeStrings.close ? window.themeStrings.close : 'Close') : (window.themeStrings && window.themeStrings.contents ? window.themeStrings.contents : 'Contents');
          $(this).text(tx);
        });
        $('.h5-links').hide();
      }
    }

    $(window).on('load', function(){
      $('.h5-links a').first().addClass('act');
    });

    $(window).scroll(function(){
      $('.h5-col').each(function(){
        var rect = this.getBoundingClientRect();
        var st = $(this).attr('data-id');
        var target = $('.h5-links a[href="#'+st+'"]');
        if(rect.top <= window.innerHeight*.5 && rect.bottom >= window.innerHeight*.5 ){
          $(target).addClass('act');
        } else {
          $(target).removeClass('act');
        }
      });
    });


    $('.default-page--content h2').each(function(){
      var els = $(this).nextUntil('h2, h5');
      var id = $(this).attr('id');
      var wrap = $('<div class="h2-col" data-id="'+id+'"></div>');
      $(wrap).insertAfter($(this));
      $(els).appendTo(wrap);
    });

    $('.default-page--content h5').each(function(){
      var els = $(this).nextUntil('h5');
      var id = $(this).attr('id');
      var wrap = $('<div class="h5-col" data-id="'+id+'"></div>');
      $(wrap).insertAfter($(this));
      $(els).appendTo(wrap);
    });

    if($('.default-page--sidebar').text().trim()==''){
      $('.default-page--sidebar').addClass('empty');
    }

    $('.default-page--content').addClass('in');
  }
}

export default defaultPage;
